import styled, { css } from 'styled-components';

import { Description } from '../styled';

interface IInfoWrapperProps {
  isExpanded: boolean;
  newPdDesignEnabled: boolean;
}

export const ExpandableDescription = styled(Description)`
  margin-top: 0;
  word-break: break-word;
`;
export const InfoWrapper = styled.div<IInfoWrapperProps>`
  ${({ newPdDesignEnabled, isExpanded }) =>
    newPdDesignEnabled
      ? css`
          height: ${isExpanded ? 'auto' : '1.75rem'};
          p {
            font-size: 1rem;
            strong {
              display: inline !important;
              font-size: 1rem !important;
              margin: 0 !important;
              font-weight: 500 !important ;
            }
          }
        `
      : css`
          height: ${isExpanded ? 'auto' : '1.5rem'};
          font-size: 0.9rem;
          line-height: 1.5rem;

          strong {
            display: inline !important;
            font-size: 0.8rem;
          }
        `}

  margin-bottom: 0.3rem !important;
  visibility: visible;
  overflow-y: hidden;
  transition: height 0.5s ease;
`;

export const ShowMoreWrapper = styled.div`
  height: 1.375rem;
`;

interface IShowMoreProps {
  showMoreButton: boolean;
}

export const ShowMore = styled.div<IShowMoreProps>`
  display: ${(props) => (props.showMoreButton ? 'flex' : 'none')};
  align-items: center;
  font-size: 0.9rem;
  text-decoration: underline;
  text-transform: uppercase;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  margin-left: 0.5rem;
`;
